import { render } from "./letter-list-full.vue?vue&type=template&id=244521ed"
import script from "./letter-list-full.vue?vue&type=script&lang=js"
export * from "./letter-list-full.vue?vue&type=script&lang=js"

import "./letter-list-full.vue?vue&type=style&index=0&id=244521ed&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__